var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "metric-card" }, [
    _vm.icon
      ? _c("div", { staticClass: "metric-card__icon" }, [
          _vm.icon.startsWith("fa-")
            ? _c("i", { class: _vm.icon })
            : _c("i", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.icon)),
              ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "metric-card__body" },
      [
        _c(
          "Tooltip",
          {
            attrs: {
              text: _vm.isCompact ? _vm.valueExact : "",
              active: _vm.isCompact,
              position: "top",
            },
          },
          [
            _c("div", { staticClass: "metric-card__value" }, [
              _vm._v(_vm._s(_vm.formattedValue)),
            ]),
          ]
        ),
        _c("div", { staticClass: "metric-card__label" }, [
          _vm._v(_vm._s(_vm.label)),
        ]),
        _vm.hasPrevious
          ? _c(
              "div",
              { staticClass: "metric-card__trend" },
              [
                _c(
                  "span",
                  { staticClass: "trend-badge", class: _vm.trendClass },
                  [
                    _c("i", { staticClass: "material-icons trend-icon" }, [
                      _vm._v(_vm._s(_vm.trendIcon)),
                    ]),
                    _vm._v("\n        " + _vm._s(_vm.trendText) + "\n      "),
                  ]
                ),
                _c(
                  "Tooltip",
                  {
                    attrs: {
                      text: _vm.isPrevCompact ? _vm.prevExact : "",
                      active: _vm.isPrevCompact,
                      position: "top",
                    },
                  },
                  [
                    _c("span", { staticClass: "metric-card__prev" }, [
                      _vm._v("vs " + _vm._s(_vm.formattedPrev)),
                    ]),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }